import React from "react";
import { withRouter } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import queryString from "query-string";
import { enc, SHA256 } from "crypto-js";
import { Button, Grid } from "@material-ui/core";
import { handleSuccessfulAuthentication } from "../api_utilities/spotify";
import CircularProgress from "@material-ui/core/CircularProgress";

class Login extends React.Component {
  CLIENT_ID = "03923be55d6742998dcb4afb917fd241";
  REDIRECT_URI = window.location.protocol + "//" + window.location.host;

  constructor(props) {
    super(props);
    this.state = {};

    if (!localStorage.getItem("spotify_auth_code_verifier")) {
      localStorage.setItem("spotify_auth_code_verifier", uuidv4() + uuidv4());
    }
    if (!localStorage.getItem("spotify_auth_state")) {
      localStorage.setItem("spotify_auth_state", uuidv4());
    }
  }

  componentDidMount() {
    const { error } = this.state;
    if (error) {
      return;
    }

    const queryParams = queryString.parse(this.props.location.search);
    if (queryParams.code && queryParams.state) {
      if (localStorage.getItem("spotify_auth_state") === queryParams.state) {
        fetch(new URL("https://accounts.spotify.com/api/token"), {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: queryString.stringify({
            client_id: this.CLIENT_ID,
            grant_type: "authorization_code",
            code: queryParams.code,
            redirect_uri: this.REDIRECT_URI,
            code_verifier: localStorage.getItem("spotify_auth_code_verifier"),
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (!data.access_token) {
              this.setState({ error: data.error_description });

              return;
            }
            handleSuccessfulAuthentication(
              data.access_token,
              data.refresh_token,
              data.expires_in
            );

            this.props.history.replace("/");
            this.props.handleLogin(data.access_token);
          });
      } else {
        this.setState({ error: "Invalid auth state" });

        return;
      }
    }
  }

  getCodeChallenge = () => {
    const challenge = SHA256(localStorage.getItem("spotify_auth_code_verifier"))
      .toString(enc.Base64)
      .replace(/=/g, "")
      .replace(/\+/g, "-")
      .replace(/\//g, "_");

    return challenge;
  };

  getSpotifyAuthorizationURL = () => {
    const authURL = new URL("https://accounts.spotify.com/authorize");
    authURL.searchParams.append("client_id", this.CLIENT_ID);
    authURL.searchParams.append("response_type", "code");
    authURL.searchParams.append("redirect_uri", this.REDIRECT_URI);
    authURL.searchParams.append("code_challenge_method", "S256");
    authURL.searchParams.append("code_challenge", this.getCodeChallenge());
    authURL.searchParams.append(
      "state",
      localStorage.getItem("spotify_auth_state")
    );
    authURL.searchParams.append(
      "scope",
      "user-modify-playback-state user-read-playback-state user-read-currently-playing playlist-modify-public playlist-modify-private playlist-read-private"
    );

    return authURL.toString();
  };

  render() {
    const { error } = this.state;

    if (error) {
      return <div>{error}</div>;
    }

    const queryParams = queryString.parse(this.props.location.search);

    return (
      <Grid container>
        <Grid item xs={4} />
        <Grid item xs={4} container justify="center">
          {Object.keys(queryParams).length > 0 ? (
            <CircularProgress />
          ) : (
            <Button
              variant="contained"
              size="large"
              color="primary"
              href={this.getSpotifyAuthorizationURL()}
              fullWidth={true}
            >
              Login to Spotify
            </Button>
          )}
        </Grid>
        <Grid item xs={4} />
      </Grid>
    );
  }
}

export default withRouter(Login);
